import { render, staticRenderFns } from "./sfc-sidebar.vue?vue&type=template&id=1c090aab&scoped=true&lang=pug&"
import script from "./sfc-sidebar.vue?vue&type=script&lang=js&"
export * from "./sfc-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sfc-sidebar.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./sfc-sidebar.vue?vue&type=style&index=1&id=1c090aab&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c090aab",
  null
  
)

export default component.exports